// src/app-instantsearch/components/InformationHit.tsx
import type { Hit as AlgoliaHit } from "algoliasearch";
import type { AlgoliaAttributes } from "../../types/AlgoliaAttributes";

export function InformationHit({
                                   hit,
                               }: {
    hit: AlgoliaHit<AlgoliaAttributes>;
}) {
    // 1) Build the link path from the full URL
    const rawUrl = typeof (hit as any).url === "string" ? (hit as any).url : "";
    const pathOnly = typeof rawUrl === "string" ? rawUrl.replace(/^https?:\/\/[^/]+\/?/, "") : "";
    const itemLink = "/" + pathOnly;

    // 2) Get Algolia’s HTML snippet or fallback to full content
    let snippetHtml: string =
        (hit as any)._snippetResult?.content?.value ??
        String(hit.content ?? "");

    // 3) Strip out the registration boilerplate
    const boilerplateRegex =
        /^Erstellen Sie mit Ihrer Registrierung[\s\S]*?Bestellhistorie verknüpfen\.(?:\s|&nbsp;|<[^>]+>)*?/i;
    snippetHtml = snippetHtml.replace(boilerplateRegex, "").trim();

    // 4) Convert any leftover highlight placeholders into real <mark> tags
    snippetHtml = snippetHtml
        .replace(/__aa-highlight__/g, "<mark>")
        .replace(/__\/aa-highlight__/g, "</mark>");

    // 5) If after stripping it’s empty, fall back to the record’s description
    if (!snippetHtml) {
        // escape any HTML just in case
        const escaped =
            typeof hit.description === "string"
                ? hit.description
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                : "";
        snippetHtml = escaped;
    }

    // 6) Pull the HTML for the highlighted title, fall back to plain title
    let titleHtml: string =
        (hit as any)._highlightResult?.title?.value ??
        String((hit as any).title ?? "");

    // 7) Convert highlight placeholders in title into <mark>
    titleHtml = titleHtml
        .replace(/__aa-highlight__/g, "<mark>")
        .replace(/__\/aa-highlight__/g, "</mark>");

    return (
        <li className="aa-Item information-item" key={hit.objectID}>
            <a href={itemLink} className="informationResults__link">
                {/* HEADLINE with real <mark> highlights */}
                <div
                    className="information__headline"
                    dangerouslySetInnerHTML={{ __html: titleHtml }}
                />

                {/* CONTENT snippet (or description fallback) */}
                <div
                    className="information__content"
                    dangerouslySetInnerHTML={{ __html: snippetHtml }}
                />
            </a>
        </li>
    );
}
